'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'rainbow';
var width = 640;
var height = 512;
var aliases = [127752];
var unicode = 'f75b';
var svgPathData = ['M16 480c8.8 0 16-7.2 16-16l0-112C32 192.9 160.9 64 320 64s288 128.9 288 288l0 112c0 8.8 7.2 16 16 16l-96 0c8.8 0 16-7.2 16-16l0-112c0-123.7-100.3-224-224-224S96 228.3 96 352l0 112c0 8.8 7.2 16 16 16l-96 0zm96 0c8.8 0 16-7.2 16-16l0-112c0-106 86-192 192-192s192 86 192 192l0 112c0 8.8 7.2 16 16 16l-96 0c8.8 0 16-7.2 16-16l0-112c0-70.7-57.3-128-128-128s-128 57.3-128 128l0 112c0 8.8 7.2 16 16 16l-96 0z', 'M320 64C160.9 64 32 192.9 32 352l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 352C0 175.3 143.3 32 320 32s320 143.3 320 320l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112C608 192.9 479.1 64 320 64zm0 192c-53 0-96 43-96 96l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-70.7 57.3-128 128-128s128 57.3 128 128l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-53-43-96-96-96zM128 352l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-123.7 100.3-224 224-224s224 100.3 224 224l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112c0-106-86-192-192-192s-192 86-192 192z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;